import { Component, inject } from '@angular/core';
import { TenureBaseComponent } from '../tenure-base/tenure-base.component';
import { ApiEnvNames, ExportConfig, SearchConfig } from '../../../model/api.model';
import { DataTableSchema,TableColumnSchema } from '../../../model/dynamic-data-table.model';
import { Props, DynamicFormArray } from '../../../model/form.model';
import { OEMTenureTitle, OEMTenureProps, OEMTenureFilterSchema, OEMTenureTableSchema, OEMTenureSearchConfig, OEMFileExportSearchConfig } from '../../../model/tenure/oem-tenure.model';
import { PageContainerComponent } from '../../../layout/page-container/page-container.component';
import { MatDialog } from '@angular/material/dialog';
import { OemTenureDetailComponent } from '../oem-tenure-detail/oem-tenure-detail.component';
import { FieldNames } from '../../../model/form-fields.model';
import { EXCEL_EXTENSION } from '../../../services/excel-export.service';
import { CommonService } from '../../../services/common.service';
import { CommonUtils } from '../../../utils/common.utils';
import { PaginatorService } from '../../../services/paginator-service.service';

@Component({
  selector: 'app-oem-tenure',
  standalone: true,
  imports: [PageContainerComponent],
  providers: [PaginatorService],
  templateUrl: './oem-tenure.component.html',
  styleUrl: './oem-tenure.component.scss',
})
export class OemTenureComponent extends TenureBaseComponent {
  protected override data: string = OEMTenureTitle;
  protected override props: Props = OEMTenureProps;
  protected override filterSchema: DynamicFormArray = structuredClone(OEMTenureFilterSchema);
  protected override dataTableSchema: DataTableSchema = structuredClone(OEMTenureTableSchema);
  protected override searchConfig: SearchConfig = structuredClone(OEMTenureSearchConfig);
  override commonUtils = inject(CommonUtils);
  protected override service: CommonService;
  constructor(readonly dialog: MatDialog) {
    super();
    this.service = inject(CommonService);
    this.updateTableCallbacks();
  }

  override handleResponse(dataArr: any) {
    return dataArr.map((data:any)=>{
      if(data[FieldNames['Attachment']]){
        data[FieldNames['Attachment']] = JSON.parse(data[FieldNames['Attachment']])
      }
      return data
    })
  }

  updateTableCallbacks() {
    this.dataTableSchema.columnSchema.forEach((col) => {
      if (col['fieldKey'] === FieldNames.Attachment) {
        col['onClick'] = this.fileDownload;
      }
    });
  } 
  fileDownload = (_record: any,args:any) => {
    const exportConfig: ExportConfig = {
      tableSchema: this.dataTableSchema,
      environment: ApiEnvNames['StaffMaster'],
      fileExtension: EXCEL_EXTENSION,
      searchParameters: OEMFileExportSearchConfig,
      exportFileName: 'OEM_file_export',
    };
    if(args) {
      this.service.downloadExcelFromS3(args, exportConfig);
    }
  }  

  columnOnClick = (record: any, _column: TableColumnSchema) => {
    const dialogRef = this.dialog.open(OemTenureDetailComponent, {
      disableClose: true,
      panelClass: 'view-oem-tenure-dialog',
      maxWidth: '100vw',
      data: {
        header: 'OEM Tenure Detail',
        response: record,
      },
    });
    dialogRef.afterClosed().subscribe((_onConfirm) => {
      dialogRef.close();
    });
  };
  
}
